<mb-side-nav
    [logoSrc]="'assets/img/logo-sm.svg'"
    [expandedLogoSrc]="'assets/img/logo-lg.svg'"
></mb-side-nav>
